window.Products.WallArt.Poster = function() {
};
window.Products.WallArt.Poster.inherits(window.Products.WallArt.ArtProduct);

window.Products.WallArt.Poster.id = 41;
window.Products.WallArt.Poster.saveId = 37;
window.Products.WallArt.Poster.slug = 'poster';
window.Products.WallArt.Poster.has_3d = true;
window.Products.WallArt.Poster.use_variants = true;
window.Products.WallArt.Poster.dpi = 300;
window.Products.WallArt.Poster.texture = new Image(1024, 1024);

window.Products.WallArt.Poster.prototype.set3dProperties = function(modelViewer) {
	modelViewer.camera_light.intensity = 0.2;
	modelViewer.camera_light.color = {r: 0.8, g: 0.8, b: 0.8};
	this.updateThreeTexture(modelViewer);
};

window.Products.WallArt.Poster.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material.map = modelViewer.texture;
};

window.Products.WallArt.Poster.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.4;
	controls.maxDistance = 2.4;
	controls.minPolarAngle = Math.PI/2;
	controls.maxPolarAngle = Math.PI/2;
	controls.minAzimuthAngle = -Math.PI/2.5;
	controls.maxAzimuthAngle = Math.PI/2.5;
};